import { isImage } from '#pplx/frontend/common/files/images.js';
import { isPresignedS3Url } from '#pplx/frontend/common/files/urls.js';
/** Reconstructs an image File through the existing storage URL resolution path. */
export async function createImageFileFromStorage({ filename, getImageUrl, mimeType, url, }) {
    if (!isImage(url))
        return null;
    // Prefer a cached local blob or an authorized storage URL over fetching the
    // original private URL. Presigned storage URLs are already fetchable.
    const fileOptions = mimeType ? { type: mimeType } : undefined;
    const fetchUrl = isPresignedS3Url(url) ? url : ((await getImageUrl?.(url)) ?? url);
    if (!fetchUrl)
        return null;
    // These blobs remain bounded by the attachment file-size limit.
    const response = await fetch(fetchUrl);
    if (!response.ok)
        throw new Error(`Failed to fetch image: ${response.status}`);
    return new File([await response.blob()], filename, fileOptions);
}
/** Reconstructs a browser File using the legacy MIME-dependent URL ingress policy. */
export async function createMediaFileFromUrl({ filename, getImageUrl, mimeType, url, }) {
    const looksLikeImage = mimeType ? mimeType.startsWith('image/') : isImage(url);
    if (looksLikeImage) {
        return createImageFileFromStorage({ filename, getImageUrl, mimeType, url });
    }
    const response = await fetch(url);
    if (!response.ok)
        throw new Error(`Failed to fetch file: ${response.status}`);
    const blob = await response.blob();
    const fileType = mimeType || blob.type || 'application/octet-stream';
    return new File([blob], filename, { type: fileType });
}
//# sourceMappingURL=mediaFileUrlIngress.js.map